import React from 'react'

import { Strings, useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'
import Tooltip from 'components_new/atoms/Tooltip'

import {
  isCoreWidgetFullyLoaded,
  TCoreWidgetSettingsLoaded,
  WidgetData
} from 'types/GlobalWidget'

interface WidgetWarningProps {
  embedded: boolean
  flag: keyof Pick<
    WidgetData,
    'is_latest_exchange_rate' | 'is_weighted_average'
  >
  labelKey: Strings<'widgets'>
  scaleFactor: number
  widget: TCoreWidgetSettingsLoaded
  tooltipKey: Strings<'widgets'>
}

const WidgetWarning = (props: WidgetWarningProps) => {
  const { embedded, flag, labelKey, scaleFactor, tooltipKey, widget } = props
  const { t } = useTranslation()

  if (!isCoreWidgetFullyLoaded(widget) || !widget.data[flag]) {
    return null
  }

  return (
    <Tooltip
      placement="bottom-start"
      title={embedded ? null : t('widgets', tooltipKey)}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          fontSize: 14 * scaleFactor,
          position: 'relative',
          zIndex: 1
        }}
      >
        <Icon color="warning" fontSize="inherit" name={'Warning'} />
        <Text
          color="warning.text"
          fontSize="inherit"
          fontWeight="medium"
          noWrap={true}
          sx={{
            cursor: 'default',
            ml: '0.25em'
          }}
        >
          {t('widgets', labelKey)}
        </Text>
      </Box>
    </Tooltip>
  )
}

export default WidgetWarning
